/* eslint-disable react/prop-types */
import React from "react";
import AsyncAutocompletePaginated from "src/Components/FormElements/Autocomplete/AsyncAutocompletePaginated";

const AsyncAutocompleteSelectFilter =
  (fetchOptions, submitForm = true, customItemsCountPerRequest) =>
  ({ filter, onChange, column }) =>
    (
      <AsyncAutocompletePaginated
        id={column.id}
        classNamePrefix="gridFilterAutocomplete"
        value={filter ? filter.value : 0}
        customItemsCountPerRequest={customItemsCountPerRequest}
        shouldFetchOnFirstEntry
        fetchOptions={fetchOptions(filter ? filter.value : null)}
        onChange={(selected) => {
          onChange(selected?.value || "");
          if (submitForm) {
            const form = document?.getElementById(column.id)?.closest("form");
            if (form) {
              const submitButton = form.querySelector('button[type="submit"]');
              setTimeout(() => {
                submitButton.click();
              }, 10);
            }
          }
        }}
      />
    );

export default AsyncAutocompleteSelectFilter;
